import { v2 } from '@saucelabs/sl-module-builds';

export const NAMESPACE = 'performance-job-build';

export const buildTypes = v2.common.types.createVDCTypes(NAMESPACE);
